<template>
    <aside class="filter" id="filter" :class="showfilters ? 'open' : null">
        <div class="filter-header container-box-shadow">
            <h2>Filter</h2>
            <a href="javascript:void(0)" class="js-filter-clear filter-clear hide-mobile" v-on:click="clearFilters()">clear all filters</a>
            <i class="icon icon-close filter-close hide-desktop" v-on:click="updateShowFilters"></i>
        </div>
        <div class="filters" id="filters">
            <div class="filter-section">

                <a href="javascript:void(0)" class="js-filter-clear filter-clear hide-desktop" v-on:click="clearFilters()">clear all filters</a>

                <h3>Category</h3>
                <ul class="filters-categories input-group">

                    <li class="category" v-for="category in categoryfilters">
                        <div class="form-group form checkox-input">
                            <input :id="'filter-' + category.ID" type="checkbox" v-model="filters.categories" :value="category.ID" />
                            <label :for="'filter-' + category.ID">{{category.Name}}</label>
                        </div>
                    </li>

                </ul>
            </div>

			<div class="filter-section">
				<h3>Webinar Type</h3>
				<ul class="filters-categories input-group">
					<li class="category">
						<div class="form-group form checkox-input">
							<input type="checkbox" name="on-demand-webinars" class="webinar-type js-on-demand on-demand" id="on-demand" value="ondemand" v-model="filters.webinarType" true-value="ondemand" false-value="" /><label for="on-demand-webinars">On-Demand</label>
						</div>
					</li>
					<li class="category">
						<div class="form-group form checkox-input">
							<input type="checkbox" name="live-webinars" class="webinar-type js-live live" id="live" value="live" v-model="filters.webinarType" true-value="live" false-value="" /><label for="live-webinars">Live</label>
						</div>
					</li>
				</ul>
			</div>

            <div class="filter-section">
                <h3>Date Range</h3>
                <div class="form-group calendar-input from-date">
                    <label for="select-from-date">From</label>
                    <input class="flatpickr" v-model="filters.from" name="from" placeholder="Date" />
                    <i class="icon icon-calendar"></i>
                </div>
				
                <div class="form-group calendar-input to-date">
                    <label for="select-to-date">To</label>
                    <input class="flatpickr" v-model="filters.to" name="to" placeholder="Date" />
                    <i class="icon icon-calendar"></i>
                </div>
            </div>
        </div>
        <div class="filter-actions" :class="filterActionsStuck ? 'static' : ''">
            <button class="btn" v-on:click="applyFilters()">Apply Filters</button>
            <a href="javascript:void(0)" class="js-filter-clear hide-mobile" v-on:click="clearFilters()">Clear Filters</a>
        </div>
    </aside>

</template>


<script>
	import flatpickr from 'flatpickr';
	import 'flatpickr/dist/flatpickr.min.css';

    export default {
	data: function() {
		return {
			filterActionsStuck: false,
			styleObject: {},
			categoryfilters: [],
			filters: {
				categories: [],
				isMySuppliers: false,
				from: '',
				to: '',
				webinarType: [],
			},
		}
		},
	props: {
		showfilters: {
			type: Boolean,
			default: () => {return false}
		},

	},
	watch: {
		showfilters: function (newVal) {
			this.showfilters = newVal;

			let body = document.getElementsByTagName("BODY")[0];

			if (newVal === true) {
				body.classList.add('collapse-shown');
				body.classList.remove('collapse-hide');

				setTimeout(() => {
					$('#filters .js-filter-clear').focus();
				}, 1000);
			}
			else {
				body.classList.add('collapse-hide');
				body.classList.remove('collapse-shown');
			}
		}
	},

	mounted() {
		this.categoryfilters = window.categoryfilters;
		flatpickr('.flatpickr', {
			altInput: true,
			altFormat: "F j, Y",
			dateFormat: "m-d-Y"
		});

		$('.from-date input:nth-of-type(2)').attr('id', 'select-from-date');
		$('.to-date input:nth-of-type(2)').attr('id', 'select-to-date');

		$(window).on('scroll', e => { this.stickFilterActions() });
	},
	components: {
		'flatpickr' : flatpickr,
	},

	methods: {

		stickFilterActions() {
			let $stickyElem = $('.filter-actions');
			let $filters = $('#filters');
			let filterOffset = Math.round($filters.offset().top);
			let filterHeight = $filters.outerHeight();
			let stickyHeight = $stickyElem.outerHeight();
			let viewHeight = $(window).height();
			let totalHeight = filterHeight + (stickyHeight * 2);

			$('.filter + .content-wrapper-main').css('min-height', totalHeight);

			let offset = filterOffset + filterHeight + stickyHeight - $(window).scrollTop();

			if ((offset <= viewHeight) && !this.filterActionsStuck) {
				this.filterActionsStuck = true;
			}
			if ((offset > viewHeight) && this.filterActionsStuck) {
				this.filterActionsStuck = false;
			}
			if (this.filterActionsStuck) {
                $stickyElem.css('top', (viewHeight - stickyHeight) + 'px');
            }
            else {
                $stickyElem.css('top', '');
			}

			if (this.filterActionsStuck) {
                $stickyElem.addClass('stuck');
            }
            else {
                $stickyElem.removeClass('stuck');
            }

		},
		applyFilters() {
        	// convert for api call
        	let formatFilters = Object.assign({}, this.filters);

        	// encode strings
			formatFilters.categories = formatFilters.categories;

        	this.$emit('setwebinarsfilters', formatFilters);
			this.updateShowFilters();
        },
		clearFilters() {
			var calendarInputs = document.getElementsByClassName('flatpickr-input');
			for (var i = 0; i < calendarInputs.length; i++) {
				if (calendarInputs[i].type == "text") {
					calendarInputs[i].value = "";
				}
			}
			var webinarTypeCheckboxes = document.getElementsByClassName('webinar-type');
			for (var i = 0; i < webinarTypeCheckboxes; i++) {
				// uncheck checkboxes
				webinarTypeCheckboxes.checked = false;
			}
			this.filters.categories = [];
			this.filters.isMySuppliers = false;
			this.filters.from = '';
			this.filters.to = '';
			this.filters.webinarType = [];

			this.$emit('clearfilters');

			this.applyFilters();
		},
		updateShowFilters() {
			this.$emit('updateshowfilters', false);
		},
	}
}

</script>